import SettingsForm from '../components/Settings/SettingsForm';
import Headbar from '../components/Headbar';

export default function Settings() {
  return (
    <>
      <Headbar />
      <SettingsForm />
    </>
  );
}
